import { InputText } from 'primereact/inputtext';
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as ClearIcon } from '../../../../assets/shared/ic-shared-clear.svg';
import { useFontClass } from '../../../tokens';

interface SelectMenuSearchInputProps {
  id: string;
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  PrefixIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const SelectMenuSearchInput = forwardRef<HTMLInputElement, SelectMenuSearchInputProps>(
  ({ id, value, onValueChange, placeholder, PrefixIcon }, ref) => {
    const { fontClass } = useFontClass();
    const handleClear = () => onValueChange('');

    const inputClass = twMerge(
      `w-full ${fontClass} text-[14px]  bg-surface-primary-bw-02 border border-outline-primary-bw-04 rounded-lg outline-none shadow-none px-[14px] py-[10px] h-[40px]`,
      PrefixIcon && '!pl-10'
    );

    return (
      <div translate='no' className='px-[8px] flex items-center relative'>
        {PrefixIcon && <PrefixIcon className='absolute top-1/2 -translate-y-1/2 left-[24px]' />}

        <InputText
          ref={ref}
          id={`${id}-drawer-text-input`}
          className={inputClass}
          placeholder={placeholder}
          value={value}
          onChange={(event) => onValueChange(event.target.value)}
        />

        {value && (
          <button
            id='ClearInput'
            className='w-fit absolute top-1/2 z-10 -translate-y-1/2 right-[16px]'
            type='button'
            onClick={handleClear}>
            <ClearIcon className='w-[20px] h-[20px]' />
          </button>
        )}
      </div>
    );
  }
);
